module.exports = __webpack_public_path__ + "static/media/Football Player.2c20f7a6.jpg";